import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserLoginFormComponent } from '../../components/user-login-form/user-login-form.component';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrl: './user-login.component.less',
  imports: [FormsModule, ReactiveFormsModule, UserLoginFormComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserLoginComponent {}
